import { useState } from "react";
import { FileText, ExternalLink, Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const kindOf = (a) => {
  const t = (a.content_type || "").toLowerCase();
  const n = (a.name || a.url || "").toLowerCase();
  if (t.startsWith("image/") || /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(n)) return "image";
  if (t === "application/pdf" || n.endsWith(".pdf")) return "pdf";
  return "other";
};

function Thumb({ a, kind }) {
  if (kind === "image") return <img src={a.url} alt={a.name} className="w-full h-full object-cover" />;
  if (kind === "pdf") return <iframe src={`${a.url}#toolbar=0&navpanes=0&view=FitH`} title={a.name} className="w-full h-full pointer-events-none bg-white" />;
  return <div className="w-full h-full grid place-items-center"><FileText className="w-8 h-8 text-slate-500" /></div>;
}

export function AttachmentPreview({ attachments = [] }) {
  const [open, setOpen] = useState(null);
  if (!attachments.length) return <div className="text-xs text-slate-600">Aucun justificatif.</div>;
  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="attachments-grid">
        {attachments.map((a) => {
          const kind = kindOf(a);
          return (
            <button key={a.id} type="button" onClick={() => (kind === "other" ? window.open(a.url, "_blank") : setOpen(a))} data-testid={`attachment-thumb-${a.id}`}
              className="group text-left rounded-lg overflow-hidden border border-[#1E293B] bg-[#0B0F17] hover:border-[#3B82F6] transition-colors">
              <div className="relative h-28 overflow-hidden">
                <Thumb a={a} kind={kind} />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 grid place-items-center transition-colors">
                  <Maximize2 className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
              <div className="px-2 py-1.5 flex items-center gap-1.5">
                <span className="text-[10px] font-mono uppercase px-1.5 py-0.5 rounded bg-[#1E293B] text-slate-400">{kind === "other" ? "fichier" : kind}</span>
                <span className="text-xs text-slate-300 truncate">{a.name}</span>
              </div>
            </button>
          );
        })}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="dark bg-[#111827] border-[#1E293B] max-w-5xl w-[95vw]" data-testid="attachment-lightbox">
          <DialogHeader>
            <DialogTitle className="text-white flex items-center gap-3 pr-6 text-sm">
              <span className="truncate">{open?.name}</span>
              {open && <a href={open.url} target="_blank" rel="noopener noreferrer" data-testid="attachment-open-new-tab" className="inline-flex items-center gap-1 text-xs text-[#3B82F6] hover:underline shrink-0"><ExternalLink className="w-3.5 h-3.5" /> Ouvrir</a>}
            </DialogTitle>
          </DialogHeader>
          {open && (kindOf(open) === "image"
            ? <img src={open.url} alt={open.name} className="max-h-[75vh] w-auto mx-auto rounded-lg" />
            : <iframe src={open.url} title={open.name} className="w-full h-[75vh] rounded-lg bg-white" />)}
        </DialogContent>
      </Dialog>
    </>
  );
}
